import BrightnessController from './BrightnessController';
import ColorController from './ColorController';
import ColorTemperatureController from './ColorTemperatureController';
import ContactSensor from './ContactSensor';
import LockController from './LockController';
import ModeController from './ModeController';
import MotionSensor from './MotionSensor';
import PercentageController from './PercentageController';
import PowerController from './PowerController';
import RangeController from './RangeController';
import SceneController from './SceneController';
import Speaker from './Speaker';
import TemperatureSensor from './TemperatureSensor';
import ThermostatController from './ThermostatController';

export default {
    BrightnessController,
    ColorController,
    ColorTemperatureController,
    ContactSensor,
    LockController,
    ModeController,
    MotionSensor,
    PercentageController,
    PowerController,
    RangeController,
    SceneController,
    Speaker,
    TemperatureSensor,
    ThermostatController,
};
